(function() {
  // Récupération immédiate des paramètres
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant');
  
  if (!variantId) return;
  
  let applied = false;

  // Setting the select is enough: the theme's own change handler syncs the
  // custom swatch dropdown from it.
  function applyVariant(retryCount = 0) {
    const maxRetries = 20;

    if (applied) return;

    const variantDataEl = document.querySelector('[data-variant-json]');
    const optionSelects = document.querySelectorAll('select[data-variant-input][data-index]');

    if (!variantDataEl || optionSelects.length === 0) {
      if (retryCount < maxRetries) {
        setTimeout(() => applyVariant(retryCount + 1), 100);
      }
      return;
    }

    let variants;
    try {
      variants = JSON.parse(variantDataEl.textContent || variantDataEl.value);
    } catch (e) {
      console.error('variant-url-fix: could not parse variant JSON', e);
      return;
    }

    const targetVariant = variants.find(v => String(v.id) === String(variantId));
    if (!targetVariant) return;

    // The theme clears the size when the frame option changes. Hold that off
    // until every option has been applied.
    window.apwApplyingUrlVariant = true;

    // Read each value by the select's data-index ("option1", "option2", ...).
    // Option positions differ between products, so order cannot be assumed.
    optionSelects.forEach(select => {
      const optionKey = select.getAttribute('data-index');
      const value = targetVariant[optionKey];

      if (!value || select.value === value) return;

      select.value = value;

      // The value is not one of this select's options; leave it alone.
      if (select.value !== value) return;

      // The size select is the only one with an empty placeholder option.
      // Mark it chosen so the next swatch click does not reset it.
      if (Array.from(select.options).some(option => option.value === '')) {
        window.userHasPickedSize = true;
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    window.apwApplyingUrlVariant = false;
    applied = true;
  }

  // Fonction d'initialisation avec plusieurs stratégies
  function init() {
    // Stratégie 1: Si le DOM est déjà complet
    if (document.readyState === 'complete') {
      setTimeout(() => applyVariant(0), 500);
    }
    
    // Stratégie 2: Attendre DOMContentLoaded
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => applyVariant(0), 500);
    });
    
    // Stratégie 3: Attendre load complet
    window.addEventListener('load', () => {
      setTimeout(() => applyVariant(0), 500);
    });
    
    // Stratégie 4: Observer les mutations pour détecter quand les éléments sont ajoutés
    const observer = new MutationObserver((mutations, obs) => {
      // Si on trouve les custom-dropdown-items, on lance
      if (document.querySelectorAll('.custom-dropdown-item').length > 0) {
        obs.disconnect();
        setTimeout(() => applyVariant(0), 200);
      }
    });
    
    // Observer le body pour les changements
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Arrêter l'observer après 5 secondes
      setTimeout(() => observer.disconnect(), 5000);
    }
  }
  
  // CSS pour stabiliser l'affichage
  const style = document.createElement('style');
  style.textContent = `
    /* S'assurer que la sélection est visible immédiatement */
    .custom-dropdown-item.selected {
      opacity: 1 !important;
      font-weight: bold;
    }
  `;
  document.head.appendChild(style);

  // Lancer l'initialisation
  init();
  
})();